import { IMirageApplications } from "@shared/mirage/core/IMirageApplications";

export class BaseClientRouter {
    public newRecordRoute = "new";

    public toRoute(...parts: string[]) {
        return parts.join("/").replace(/\/\/+/, "/");
    }
    public toRecordRoute(path: string, id: number) {
        return this.toRoute(path, id.toString());
    }
    public toNewRecordRoute(path: string, params?: { [name: string]: string }) {
        const qs = new URLSearchParams(params).toString();
        return this.toRoute(path, this.newRecordRoute) + (qs ? `?${qs}` : "");
    }
}

export interface IBaseClientRouter {
    AppName: IMirageApplications;
    Root: string;
    newRecordRoute: string;
    toRoute(...parts: string[]): string;
}
